/**
 * PSTUDIO-2872: context-menu label that scales to the selection count, e.g.
 * "Insert 3 nodes above". Hardcoded English to match the rest of the row
 * context menu (which is not yet i18n-migrated).
 */
export function buildInsertNodesLabel(
  count: number,
  direction: 'above' | 'below'
): string {
  const n = Math.max(1, Math.floor(count) || 1);
  return `Insert ${n} node${n === 1 ? '' : 's'} ${direction}`;
}
